/**
 * Empty state component for no data scenarios.
 * 
 * @module components/ui/EmptyState
 */

import { Inbox } from 'lucide-react';
import type { EmptyStateProps } from '../../types';

/**
 * Empty state display for when no data is available.
 * 
 * @param props - EmptyState properties
 * @returns EmptyState element
 */
export function EmptyState({
  title,
  description,
  icon,
  action,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
      <div className="p-4 bg-gray-100 rounded-full mb-4">
        {icon || <Inbox className="h-8 w-8 text-gray-400" />}
      </div>
      <h3 className="text-lg font-medium text-gray-900 mb-2">{title}</h3>
      {description && (
        <p className="text-sm text-gray-500 max-w-md mb-6">{description}</p>
      )}
      {action && <div>{action}</div>}
    </div>
  );
}
